import { IEventRequestParams, IImageUploadUrl } from './shared.dto';

abstract class IEmailConfigurationDAO {
    public abstract getTemplatesConfiguration(params: IEventRequestParams): Promise<IEmailsTemplateConfiguration>;
    public abstract getDefaultTemplatesConfiguration(params: IEventRequestParams): Promise<IEmailsTemplateConfiguration>;
    public abstract updateTemplatesConfiguration(params: IEventRequestParams & IEmailsTemplateConfiguration): Promise<IEmailsTemplateConfiguration>;
    public abstract sendEmailPreview(type: string, params: IEventRequestParams): Promise<void>;
}

interface IEmailTemplateFields {
    body: string;
    configurationId?: number;
    location: string;
    logo: IImageUploadUrl;
    name: string;
    subject: string;
    type: string;
    subtype: string;
    enabled: boolean;
    autoSubscribed: boolean;
}

interface IEmailTemplatesErrorConfig {
    emailSubjectError?: string;
    emailBodyError?: string;
    emailLocationError?: string;
}

enum EmailTemplateType {
    REGISTRATION_SUCCESSFUL = 'REGISTRATION_SUCCESSFUL',
    REGISTRATION_WITH_SESSIONS = 'REGISTRATION_WITH_SESSIONS',
    REGISTRATION_CALENDAR_INVITATION = 'REGISTRATION_CALENDAR_INVITATION',
    MEETING_CALENDAR_INVITATION = 'MEETING_CALENDAR_INVITATION',
    BOOKABLE_MEETING_CALENDAR_INVITATION = 'BOOKABLE_MEETING_CALENDAR_INVITATION',
    PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION = 'PRESENTER_BOOKABLE_MEETING_CALENDAR_INVITATION',
}

interface IAvailableTypes {
    name: string;
    type: keyof typeof EmailTemplateType;
}

interface IEmailsTemplateConfiguration {
    configurations: IEmailTemplateFields[];
    triagedRegistrationEnabled?: boolean;
    availableSubtypes?: string[];
    availableTypes?: IAvailableTypes[];
}

export {
    IEmailConfigurationDAO,
    IEmailTemplatesErrorConfig,
    IEmailsTemplateConfiguration,
    IEmailTemplateFields,
    IAvailableTypes,
    EmailTemplateType
};
